import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1 text-sm text-foreground-500">
      <Link to="/" className="cursor-pointer transition-colors hover:text-accent-600">
        首页
      </Link>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1">
          <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true"></i>
          {item.to ? (
            <Link to={item.to} className="cursor-pointer transition-colors hover:text-accent-600">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}